import {EventTemplateStatus} from "../../../../shared/enums/eventTemplateStatus";

export class EventTemplateDetail {
  id: string;
  categoryName: string;
  title: string;
  eventTemplateStatus: EventTemplateStatus;
  duration: string;
  description: string;
  isVillageFavourite: boolean;

  constructor(
    id: string,
    categoryName: string,
    title: string,
    eventTemplateStatus: EventTemplateStatus,
    duration: string,
    description: string,
    isVillageFavourite: boolean
  ) {
    this.id = id;
    this.categoryName = categoryName;
    this.title = title;
    this.eventTemplateStatus = eventTemplateStatus;
    this.duration = duration;
    this.description = description;
    this.isVillageFavourite = isVillageFavourite;
  }
}
